import { TextField } from '@mui/material'
import './index.scss'

export default function BasicInput({
  className = '',
  label,
  placeholder,
  value,
  onChange,
  onKeyDown,
  error,
  helperText,
  type = 'text',
  inputMode,
  maxLength
}) {
  return (
    <div className={`TrafficViolationsBasicInput ${className}`.trim()}>
      <TextField
        fullWidth
        type={type}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        margin="normal"
        error={Boolean(error)}
        helperText={helperText || error || ''}
        InputProps={{
          inputProps: {
            inputMode,
            maxLength
          }
        }}
      />
    </div>
  )
}
